<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">{{ resposta.id ? 'Editar' : 'Adicionar' }} Resposta Rápida</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-4">
                      <label for="atalho">
                        <span class="required">*</span> Atalho:
                        <small class="text-muted">(ex: /boasvindas)</small>
                      </label>
                      <input autocomplete="new-password" type="text" id="atalho" class="form-control" v-model="resposta.atalho" />
                    </div>
                    <div class="col-md-4">
                      <label for="titulo">
                        <span class="required">*</span> Título:
                      </label>
                      <input type="text" id="titulo" class="form-control" v-model="resposta.titulo" />
                    </div>
                    <div class="col-md-4">
                      <label for="departamento_id">Departamento:</label>
                      <select v-model="resposta.departamento_id" class="form-control">
                        <option :value="null">Global (todos os departamentos)</option>
                        <option v-for="dep in departamentos" :key="dep.id" :value="dep.id">{{ dep.nome }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row mt-1">
                    <div class="col-md-9">
                      <label for="conteudo">
                        <span class="required">*</span> Conteúdo:
                      </label>
                      <textarea id="conteudo" class="form-control" rows="4" v-model="resposta.conteudo"></textarea>
                    </div>
                    <div class="col-md-3">
                      <label for="status">Status:</label>
                      <select v-model="resposta.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/respostas_rapidas" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "respostaRapidaAdd",
  data() {
    return {
      resposta: {
        status: '1',
        departamento_id: null,
      },
      departamentos: [],
      errors: undefined,
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "respostas_rapidas";

      if (self.resposta.id) {
        self.resposta._method = "PUT"
        api += "/" + self.resposta.id;
      }

      axios
        .post(api, self.resposta)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/respostas_rapidas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getResposta: function (id) {
      const self = this;
      const api = self.$store.state.api + "respostas_rapidas/" + id;

      axios
        .get(api)
        .then((response) => {
          self.resposta = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartamentos: function () {
      const self = this;
      const api = self.$store.state.api + "departamentos";

      axios
        .get(api, { params: { paginated: false } })
        .then((response) => {
          self.departamentos = response.data.data;
        })
        .catch(() => {});
    },
  },
  mounted: function () {
    const self = this;
    self.getDepartamentos();
    let id = self.$route.params.id;
    if (id) {
      self.getResposta(id);
    }
  },
};
</script>
